import React, { useState, useEffect } from "react";
import ConvertZMelody from "./images/convert_zmelody.svg";

function ConvertApp() {
  const [count, setCount] = useState(5);

  useEffect(() => {
    const countdown = setInterval(() => {
      setCount((prevCount) => prevCount - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(countdown);
      window.location.href = "https://zbox.vn?utm_source=zmelody_page";
    }, 5000);

    return () => {
      clearInterval(countdown);
    };
  }, []);

  return (
    <div
      className="w-full px-8 flex flex-col justify-center items-center bg-white"
      style={{
        height: "calc(100vh)",
      }}
    >
      <img src={ConvertZMelody} />
      <div className="px-6 flex flex-col justify-center items-center text-center space-y-4">
        <p className="text-xl font-bold text-[#212121]">
          zMelody đã được chuyển thành zStyle
        </p>
        <p className="md:w-[444px] text-sm font-normal text-[#212121B2]">
          Dịch vụ nhạc chờ zMelody đã được chuyển thành zStyle. Bạn sẽ được
          chuyển hướng đến trang web mới trong giây lát...
        </p>
        <p className="p-2 text-base font-medium text-[#0068FF]">
          Đang chuyển hướng ({count})
        </p>
      </div>
    </div>
  );
}

export default ConvertApp;
